import { usePageExperienceContextOptional } from '@/features/experiences/contexts/PageExperienceContext';

export const useIsExperiencePage = (): boolean =>
  Boolean(usePageExperienceContextOptional());
